import React, { useMemo } from 'react';
import Button from './UI/Button';

// Props:
// - summary: GET /api/loans/my-summary (overdue: the loans the API counts as late)
// - loans: array (each with the API's state.next_payment)
// - onViewInvoice: fn(loan)
const DueAlertsStrip = ({ summary = null, loans = [], onViewInvoice }) => {
  const { overdue, dueSoon } = useMemo(() => {
    const byId = new Map((loans || []).map(l => [l.id, l]));
    const overdue = (summary?.overdue || []).map(o => byId.get(o.id) || o);
    const overdueIds = new Set(overdue.map(l => l.id));
    // The next instalment falls within the week.
    const dueSoon = (loans || []).filter(l => {
      const days = Number(l.state?.next_payment?.days_until);
      return !overdueIds.has(l.id) && l.state?.next_payment && days >= 0 && days <= 7;
    });
    return { overdue, dueSoon };
  }, [summary, loans]);

  if (overdue.length === 0 && dueSoon.length === 0) return null;

  return (
    <div className="mb-4 flex flex-col gap-2">
      {overdue.length > 0 && (
        <div className="flex items-center justify-between bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 text-red-800 dark:text-red-300 rounded-lg px-3 py-2">
          <span className="text-sm">{overdue.length} loan(s) overdue</span>
          {typeof onViewInvoice === 'function' && (
            <div className="flex gap-2">
              {overdue.slice(0,3).map(loan => (
                <Button key={loan.id} size="sm" variant="primary" onClick={() => onViewInvoice(loan)} title="Open the invoice">{loan.loan_code || `Loan #${loan.id}`}</Button>
              ))}
            </div>
          )}
        </div>
      )}
      {dueSoon.length > 0 && (
        <div className="flex items-center justify-between bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 text-yellow-800 dark:text-yellow-300 rounded-lg px-3 py-2">
          <span className="text-sm">{dueSoon.length} loan(s) due within 7 days</span>
          {typeof onViewInvoice === 'function' && (
            <div className="flex gap-2">
              {dueSoon.slice(0,3).map(loan => (
                <Button key={loan.id} size="sm" onClick={() => onViewInvoice(loan)} title="Open the invoice">{loan.loan_code || `Loan #${loan.id}`}</Button>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default DueAlertsStrip;
